import { Box, Button, IconButton, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

/** The wireframe's "+ Add Question" list — one text box per entry of a free-text ArrayField. */
export default function RepeatableTextList({ value, onChange, addLabel = 'Add Question', placeholder }) {
  const handleItemChange = (index, text) => onChange(value.map((item, i) => (i === index ? text : item)));
  const handleRemove = (index) => onChange(value.filter((_, i) => i !== index));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {value.map((item, index) => (
        <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <TextField
            hiddenLabel
            fullWidth
            multiline
            minRows={2}
            size="small"
            placeholder={placeholder}
            value={item}
            onChange={(e) => handleItemChange(index, e.target.value)}
          />
          <IconButton size="small" color="error" aria-label="Remove" onClick={() => handleRemove(index)} sx={{ mt: 0.5 }}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Box>
        <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => onChange([...value, ''])}>
          {addLabel}
        </Button>
      </Box>
    </Box>
  );
}
